import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, vModelSelect as _vModelSelect } from "vue";
const _hoisted_1 = ["disabled", "placeholder"];
const _hoisted_2 = ["name", "value"];
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
  key: 0,
  class: "searchable-select-group px-3 pt-2 pb-1 small text-muted fw-semibold text-uppercase"
};
const _hoisted_5 = ["onMousedown"];
const _hoisted_6 = ["disabled", "name"];
const _hoisted_7 = {
  value: ""
};
const _hoisted_8 = ["label"];
const _hoisted_9 = ["value"];
const _hoisted_10 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["searchable-select position-relative", _ctx.$attrs.class]),
    style: _normalizeStyle(_ctx.$attrs.style)
  }, [$options.searchable ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_withDirectives(_createElementVNode("input", _mergeProps({
    ref: "control"
  }, $options.controlAttrs, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.search = $event),
    class: $options.controlClass,
    disabled: $props.disabled,
    placeholder: $props.placeholder,
    autocomplete: "off",
    type: "text",
    onBlur: _cache[1] || (_cache[1] = (...args) => $options.closeList && $options.closeList(...args)),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.reopenList && $options.reopenList(...args)),
    onFocus: _cache[3] || (_cache[3] = (...args) => $options.openList && $options.openList(...args)),
    onInput: _cache[4] || (_cache[4] = (...args) => $options.handleSearch && $options.handleSearch(...args)),
    onKeydown: [_cache[5] || (_cache[5] = _withKeys(_withModifiers($event => $options.moveHighlight(1), ["prevent"]), ["down"])), _cache[6] || (_cache[6] = _withKeys(_withModifiers($event => $options.moveHighlight(-1), ["prevent"]), ["up"])), _cache[7] || (_cache[7] = _withKeys(_withModifiers((...args) => $options.chooseHighlighted && $options.chooseHighlighted(...args), ["prevent"]), ["enter"])), _cache[8] || (_cache[8] = _withKeys((...args) => $options.escapeList && $options.escapeList(...args), ["esc"]))]
  }), null, 16, _hoisted_1), [[_vModelText, _ctx.search]]), $props.name ? (_openBlock(), _createElementBlock("input", {
    key: 0,
    name: $props.name,
    value: $props.modelValue || '',
    type: "hidden"
  }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("button", {
    disabled: $props.disabled,
    "aria-hidden": "true",
    class: "searchable-select-toggle",
    tabindex: "-1",
    type: "button",
    onMousedown: _cache[9] || (_cache[9] = _withModifiers((...args) => $options.toggleList && $options.toggleList(...args), ["prevent"]))
  }, null, 40, _hoisted_3), (_openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [_ctx.focused && ($options.listRows.length || $options.hasValue) ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    ref: "list",
    style: _normalizeStyle(_ctx.listStyle),
    class: "searchable-select-list bg-white border rounded shadow-sm overflow-auto"
  }, [!_ctx.search ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "searchable-select-item searchable-select-empty btn btn-link d-block w-100 text-start text-decoration-none text-muted",
    type: "button",
    onMousedown: _cache[10] || (_cache[10] = _withModifiers((...args) => $options.clearAndClose && $options.clearAndClose(...args), ["prevent"]))
  }, _toDisplayString($props.placeholder || '—'), 33)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.listRows, (row, rowIndex) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: rowIndex
    }, [row.type === 'group' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(row.group), 1)) : (_openBlock(), _createElementBlock("button", {
      key: 1,
      class: _normalizeClass([{
        'is-highlighted': row.index === _ctx.highlighted,
        'searchable-select-item--grouped': !!$props.groupField || !!$props.levelField && row.option?.[$props.levelField] > 0
      }, "searchable-select-item btn btn-link d-block w-100 text-start text-decoration-none"]),
      type: "button",
      onMousedown: _withModifiers($event => $options.selectOption(row.option), ["prevent"])
    }, _toDisplayString($options.getOptionLabel(row.option)), 43, _hoisted_5))], 64);
  }), 128))], 4)) : _createCommentVNode("", true)]))], 64)) : _withDirectives((_openBlock(), _createElementBlock("select", _mergeProps({
    key: 1,
    ref: "control"
  }, $options.controlAttrs, {
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $options.nativeValue = $event),
    class: $options.controlClass,
    disabled: $props.disabled,
    name: $props.name || undefined
  }), [_createElementVNode("option", _hoisted_7, _toDisplayString($props.placeholder || '—'), 1), $props.groupField ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($options.groupedOptions, grp => {
    return _openBlock(), _createElementBlock("optgroup", {
      key: grp.group,
      label: grp.group
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grp.items, option => {
      return _openBlock(), _createElementBlock("option", {
        key: option?.[$props.valueField],
        value: String(option?.[$props.valueField])
      }, _toDisplayString($options.getOptionLabel(option)), 9, _hoisted_9);
    }), 128))], 8, _hoisted_8);
  }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($props.options, option => {
    return _openBlock(), _createElementBlock("option", {
      key: option?.[$props.valueField],
      value: String(option?.[$props.valueField])
    }, _toDisplayString($options.getOptionLabel(option)), 9, _hoisted_10);
  }), 128))], 16, _hoisted_6)), [[_vModelSelect, $options.nativeValue]]), $props.clearable && $props.modelValue !== null && $props.modelValue !== undefined && $props.modelValue !== '' ? (_openBlock(), _createElementBlock("button", {
    key: 2,
    class: "searchable-select-clear",
    type: "button",
    "aria-label": "Törlés",
    onMousedown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
    onClick: _cache[13] || (_cache[13] = (...args) => $options.clear && $options.clear(...args))
  }, "×", 32)) : _createCommentVNode("", true)], 6);
}